export default __webpack_public_path__ + "static/media/carbohydrate.51c0a112.jpg";